import WorkOrderSearchContext from "contexts/WorkOrderSearchContext";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import useGetWorkOrders from "hooks/apollo/workOrder/useGetWorkOrders";
import useSlideOutState from "hooks/state/useSlideOutState";
import debounce from "lodash/debounce";
import isEmpty from "lodash/isEmpty";
import React, { useContext } from "react";
import FilterSidebarView from "./FilterSidebarView";

export default function FilterSidebarContainer() {
  const { isFilterMode } = useSlideOutState();
  const visible = isFilterMode();
  const applicationContext = useApplicationContext();
  const { fetch: filterWorkOrders } = useGetWorkOrders();
  const { state: searchState, setState: setSearchState } = useContext(WorkOrderSearchContext);

  const handleChangeFilter = (changedFilter) => filterWorkOrders(setSearchState({ filters: changedFilter }));
  const handleChangeSelect = (key) => (values) => handleChangeFilter({ [key]: isEmpty(values) ? null : values });
  const handleToggleFilter = (filterName) => handleChangeFilter({ [filterName]: !searchState.filters[filterName] });

  const handleToggleFilterByScheduleView = () => {
    handleChangeFilter({
      filterByScheduleView: !searchState.filters.filterByScheduleView,
      scheduledBetween: { endsAt: null, startsAt: null },
    });
  };

  const handleTextSearch = debounce((filter) => {
    handleChangeFilter(filter);
  }, 500);

  if (!visible) return null;

  return (
    <FilterSidebarView
      applicationContext={applicationContext}
      currentFilter={searchState.filters}
      onChangeFilter={handleChangeFilter}
      onChangeSelect={handleChangeSelect}
      onChangeToggleFilter={handleToggleFilter}
      onTextSearch={handleTextSearch}
      onToggleFilterByScheduleView={handleToggleFilterByScheduleView}
    />
  );
}
